<template>
    <div style="height: 100%">
      <div v-if="!this.isLoadingHierarquia">
        <div v-if="!$vuetify.breakpoint.xs || hierarquia[2].length > 1" class="my-10">
          <v-row>
                <v-col
                    v-for="(item, index) in hierarquia"
                    :key="index"
                    cols="3"
                    :style="topSpace(hierarquia, index)"
                >
                    <div v-for="(i, indexItem) in item" :key="indexItem">
                      <hierarquia-card
                        :currentUnit="index == hierarquia.length - 1"
                        :unidadeID="i.codigo"
                        :unidadeName="i.nomeUnimed"
                        :tipoCooperativa="i.tipoUnimed.nome"
                        :tipoAtuacao="i.tipoAtuacao.nome"
                        :cardPai="cardPaiComputed(index, hierarquia) && paiSecundario"
                        :cardFilho="item.length > 1"
                        :index="indexItem"
                        :mobile="false"
                      />
                    </div>
                </v-col>
            </v-row>
        </div>
        <div v-else>
            <v-row>
                <v-col
                  v-for="(item, index) in hierarquia"
                  :key="index"
                  cols="12"
                >
                  <div v-for="(i, indexItem) in item" :key="indexItem">
                    <hierarquia-card
                        :currentUnit="index == hierarquia.length - 1"
                        :unidadeID="i.codigo"
                        :unidadeName="i.nomeUnimed"
                        :tipoCooperativa="i.tipoUnimed.nome"
                        :tipoAtuacao="i.tipoAtuacao.nome"
                        :cardPai="cardPaiComputed(index, hierarquia) && paiSecundario"
                        :cardFilho="item.length > 1"
                        :index="indexItem"
                        mobile
                    />
                  </div>
                </v-col>
            </v-row>
        </div>
      </div>
      <component-loading :value="isLoadingHierarquia"/>
      <ErrorModal
        v-model="error"
        :errObj="errObj"
      />
    </div>
</template>

<script>
import jwtDecode from 'jwt-decode'

import Hierarquia from '../../../../services/Hierarquia'

import ErrorModal from '../../../Shared/ErrorModal/ErrorModal'

export default {
  components: {
    ErrorModal
  },

  data () {
    return {
      isLoadingHierarquia: true,
      hierarquia: [],
      amount: 0,
      error: false,
      errObj: {
        status: 'Status',
        error: 'Error'
      },
      paiSecundario: false
    }
  },

  async beforeMount () {
    this.tokenBearer = localStorage.getItem('tokenBearer')
    let decoded = jwtDecode(this.tokenBearer)

    this.role = decoded.role
    this.id = this.$idUnimed

    this.getAllHierarquia()
  },

  methods: {
    topSpace (hierarquia, index) {
      return (index === hierarquia.length - 1 && this.paiSecundario) ? { 'position': 'relative', 'top': 72 * index + 'px' } : { 'position': 'relative', 'top': 56 * index + 'px' }
    },
    async getAllHierarquia () {
      let hierarquia = new Hierarquia(this.tokenBearer, this.$appConfig.config.API, this.id)

      try {
        let responseHierarquia = await hierarquia.getHierarquia()
        responseHierarquia = responseHierarquia.data
        this.popularHierarquia(responseHierarquia)
        this.$emit('complete')
      } catch (err) {
        console.error(err)
        this.isLoadingHierarquia = false
        this.$emit('complete')
        this.error = true
        this.errObj.status = err.response.status
        this.errObj.error = err.response.data.message
      }
    },
    pushHierarquia (item, index) {
      this.hierarquia[index].push({
        codigo: item.codigo,
        nomeUnimed: item.nomeFantasia,
        tipoUnimed: {
          id: item.tipoUnimed.id,
          nome: item.tipoUnimed.nome
        },
        tipoAtuacao: {
          id: item.tipoAtuacao.id,
          nome: item.tipoAtuacao.nome
        }
      })
    },
    popularHierarquia (hierarquia) {
      hierarquia = hierarquia.filter((el) => !el.ignorado)
      hierarquia.forEach((item, index) => {
        this.hierarquia[index] = []
        if (item.paiSecundario) {
          let itemPai = item.paiSecundario
          this.paiSecundario = true

          this.pushHierarquia(itemPai, index - 1)
        }

        this.pushHierarquia(item, index)
      })
      this.isLoadingHierarquia = false
    },
    cardPaiComputed (index, hierarquia) {
      return index !== hierarquia.length && (hierarquia[index + 1] ? hierarquia[index + 1].length > 1 : false)
    }
  }
}
</script>

<style scoped>
    .cardHierarquia{
        width: 100%;
        height: 121px;
        background-color: #00995D;
        border: 1px solid #FFFFFF;
        border-radius: 5px;
        padding: 15px 5px 5px 10px;
    }

    .textHierarquia{
        margin: 0;
        text-align: left;
        font: Regular 11px/25px Trebuchet MS;
        letter-spacing: 0;
        color: #FFFFFF;
        opacity: 1;
    }
</style>
